/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

'use strict';

var _config = require('../config');

var _isomorphicFetch = require('isomorphic-fetch');

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

var _config2 = require('../../utils/config');

var _tool = require('../../utils/tool');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//获取设备列表
var getDeviceType = function getDeviceType(data) {
  return function (dispatch) {
    return (0, _tool.http)(_config2.apiJson.getDeviceType, data).then(function (data) {
      dispatch({ type: _config.GET_DEVICE_TYPE, data: data });
    }).catch(function (error) {
      return console.log(error);
    });
  };
};

// 区分设备类型
var getEruipmentType = function getEruipmentType(data) {
  return function (dispatch) {
    console.log('data:' + data);
    dispatch({
      type: _config.EQUIPMENT,
      data: data
    });
  };
};

module.exports = {
  getDeviceType: getDeviceType,
  getEruipmentType: getEruipmentType
};

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "product.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/redux/actions/product.jsx
// module id = 652
// module chunks = 0